import OnboardingLayout from './OnboardingLayout';
export default OnboardingLayout;
